<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="ch7" title="Why Does Bacon Smell So Good?">
<p class="h2a"><a href="#/text/Contents#rch7">Why Does Bacon Smell So Good?</a></p>
<figure>
<p class="image"><img alt="" height="193" src="images/f011.jpg" width="193"/></p>
</figure>
<p class="noindent1">Very few aromas will get a person’s mouth watering like the smell of bacon cooking. Even vegetarians have been known to falter under its powers. But what makes it different from other meats?</p>
<p class="indent">When bacon is cooked, it undergoes a process called the Maillard reaction. Named after the 20th century French chemist Louis-Camille Maillard, the Maillard reaction is the chemical process responsible for turning food brown and giving it aroma and flavor. When bacon is heated, the molecular structure of its sugars begins to break down and react with the amino acids that are released. This reaction releases about 150 complex aroma compounds, far more than other foods.</p>
<p class="indent"><span class="right_1" epub:type="pagebreak" id="page_12" title="12">The majority of these compounds are hydrocarbons and aldehydes, both of which give off delicious smells. This happens with most meats, but bacon has a secret weapon. When it has been cured with salt or brine, it contains a higher percentage of nitrates, specifically pyridines, than other meats have. When pyridines mix with the hydrocarbons and aldehydes, a volatile combination explodes, and that’s what gives bacon its unique smell.</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter007.vue?08c273a7